import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NavigationScroll = (props:any) => {
    const location = useLocation();
    const { pathname } = location;

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, [pathname]);

    return props.children || null;
};

NavigationScroll.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
};

export default NavigationScroll;
